import React from "react";
import { ThemeProvider } from "../ThemeProvider";
import { AuthProvider } from "../contexts/AuthContext";
import { FarmProvider } from "../contexts/FarmContext";
import { UserRaceProvider } from "../contexts/UserRaceContext";
import { CardSettingsProvider } from "../contexts/CardSettingsContext";
import { ChatDialogProvider } from "../contexts/ChatDialogContext";
import { CookieConsentProvider } from "../contexts/CookieConsentContext";
import { CalfERPSettingsProvider } from "../contexts/CalfERPSettingsContext";

interface AppProvidersProps {
  children: React.ReactNode;
}

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => (
  <CookieConsentProvider>
    <ThemeProvider>
      <AuthProvider>
        <FarmProvider>
          <CalfERPSettingsProvider>
            <UserRaceProvider>
              <CardSettingsProvider>
                <ChatDialogProvider>{children}</ChatDialogProvider>
              </CardSettingsProvider>
            </UserRaceProvider>
          </CalfERPSettingsProvider>
        </FarmProvider>
      </AuthProvider>
    </ThemeProvider>
  </CookieConsentProvider>
);

export default AppProviders;
